<template>
  <div>
    <ul>
      <li
        v-for="(item, index) in listItems"
        :key="index"
      >
        <template
          v-for="(cont, i) in item.content"
        >
          <Paragraph
            :content="cont.content"
            v-if="cont.type === 'paragraph'"
            :key="`list-paragraph-${i}`"
          />
        </template>
      </li>
    </ul>
  </div>
</template>

<script>

import Paragraph from '@/components/post/Blocks/Paragraph.vue'

export default {
  name: 'BulletList',
  props: ['content'],
  components: {
    Paragraph
  },
  computed: {
    listItems () {
      return this.content.filter(item => {
        return item.type === 'list_item' || item.type === 'listItem'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* LIST */
::v-deep {
  ul,
  ol {
      padding-left: $spacing_large;
      li {
        list-style: disc;
      }
  }

  li > p,
  li > ol,
  li > ul {
      margin: 0;
  }
}

</style>
